import { useLocale } from "next-intl"
import styles from "./LangSelector.module.scss"

export default function LangSelector({ item, className }) {
  const lang = useLocale()
  if (item.languages.length < 2) return null
  const checkActive = (el) => {
    return (lang === "" && el.code === "en") || lang === el.code
  }

  return (
    <ul className={`${styles.langselector} ${className}`}>
      {item.languages.map((el, index) => {
        return (
          <li key={el.code + String(checkActive(el))}>
            {checkActive(el) ? (
              <span className={`${styles.lang} ${styles.active}`}>
                {el.name_en}
              </span>
            ) : (
              <a
                href={`/${el.code}/events/${item.slug}/`}
                // className={`${styles.intro__lang} ${
                //   checkActive(el) ? styles.active : ""
                //   }`}
                className={styles.lang}
              >
                {el.name_en}
              </a>
            )}
            {/* <label
                      className={`${styles.intro__lang} ${
                        checkActive(el) ? styles.active : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="lang"
                        value={el.code}
                        id={`lang_${el.code}`}
                        checked={checkActive(el)}
                      />
                      {el.code === "en" ? (
                        <a href={`/events/${item.slug}`}>{el.name_en}</a>
                      ) : (
                        <a href={`/events/${el.code}/${item.slug}`}>
                          {el.name_en}
                        </a>
                      )}
                    </label> */}
          </li>
        )
      })}
    </ul>
  )
}
